import React, { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';

import { BalanceButton } from '@/components/BalanceButton';
import { SocialCurrencyActiveIcon } from '@/components/SocialCurrencyActiveIcon';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useActiveWallet } from '@/hooks/use-active-wallet';
import { useFormatCurrency } from '@/hooks/use-format-currency';
import { SocialCurrency, useSocialCurrencyStore } from '@/hooks/use-social-currency';
import { useUserStore } from '@/hooks/use-user-store';

export const SocialWalletBetSlipBalanceButton = () => {
    const activeCurrency = useSocialCurrencyStore(state => state.activeCurrency);
    const { wallets } = useActiveWallet();
    const coinsBalance = wallets.sweeps.COINS?.total || 0;
    const cashBalance = Number(wallets.sweeps.CASH?.real_amount) + Number(wallets.sweeps.CASH?.bonus_amount) || 0;
    const balance = activeCurrency === SocialCurrency.CASH ? cashBalance : coinsBalance;
    const navigation = useNavigation();

    const { formatCurrency } = useFormatCurrency();

    const handleBalancePress = useCallback(() => {
        navigation.navigate('DepositStack', { screen: 'CoinPackageScreen' });
    }, [navigation]);

    const guest = useUserStore(state => state.guest);
    if (guest) {
        return null;
    }

    return (
        <BalanceButton
            leftIcon={
                <Box mr={'s8'}>
                    <SocialCurrencyActiveIcon />
                </Box>
            }
            textColor={balance === 0 ? ds.colorToken.text.danger : ds.colorToken.text.primary}
            balance={formatCurrency(balance)}
            onPress={handleBalancePress}
        />
    );
};
